/**
 * Created by bartdecorte on 16/05/2017.
 */
import EntriesAssets from './EntriesAssets';
import 'jstree';

class EntriesFiles extends EntriesAssets {
  constructor() {
    const dropzoneParams = {
      type: 'file',
    };
    super(dropzoneParams);

    this.itemSelector = '[data-url]';
    this.initializeTree();
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    $('.js-tree').on('select_node.jstree', (ev, data) => this.lThumbClicked(ev, data));
    super.bindListeners();
  }

  lThumbClicked(ev, data) {
    if (data.node.type !== 'file') {
      return;
    }
    let $elt = $('#' + data.selected[0]);
    let url = $elt.find('[data-url]').data('url');
    this.propagateToCkEditor(url);
  }

  initializeTree() {
    $('.js-tree').jstree({
      core: {
        check_callback: true,
        themes: {
          dir: 'images',
          dots: true,
          icons: true,
          name: false,
          responsive: false,
          stripes: false,
          url: false,
          variant: false,
        },
      },
      plugins: ['types', 'dnd'],
      types: {
        default: {
          icon: 'fe fe-folder',
        },
        file: {
          icon: 'fe fe-file',
        },
      },
    });
  }
}

export default EntriesFiles;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/EntriesFiles.js